let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lF2XI")).then(() => parcelRequire('12Lpf'));